export function isSuccessResponse(response) {
    return response.identity !== undefined && response.status !== undefined &&
        response.reference !== undefined;
}
export function isFailureResponse(response) {
    return response.code !== undefined && response.status !== undefined &&
        response.reference !== undefined && response.reason !== undefined;
}
export function isSuccessWithConditionResponse(response) {
    return response.identity !== undefined && response.status !== undefined &&
        response.reference !== undefined && response.conditions_data !== undefined
        && response.conditions !== undefined;
}
